import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';

import { NamedLink } from '../../../../components';

import css from './Join.module.css';

/**
 * Closing invitation to create a provider profile.
 */
const Join = () => (
  <section className={css.root}>
    <div className={css.inner}>
      <p className={css.eyebrow}>
        <FormattedMessage id="ForProvidersJoin.eyebrow" defaultMessage="Join PostPartners" />
      </p>
      <h2 className={css.title}>
        <FormattedMessage
          id="ForProvidersJoin.title"
          defaultMessage="Join the network families turn to for perinatal care"
        />
      </h2>
      <NamedLink
        className={css.button}
        name="SignupForUserTypePage"
        params={{ userType: 'provider' }}
      >
        <FormattedMessage id="ForProvidersJoin.button" defaultMessage="Start your profile" />
      </NamedLink>
    </div>
  </section>
);

export default Join;
